import type { Contest } from '@/types';

/** Shaped exactly like the API, so screens behave the same either way. */

const hoursFromNow = (hours: number): string =>
  new Date(Date.now() + hours * 60 * 60 * 1000).toISOString();

const now = new Date().toISOString();

export const MOCK_CONTESTS: readonly Contest[] = [
  {
    id: 'ct_weekly',
    name: 'Weekly Challenge',
    period: 'Gameweek 5',
    status: 'open',
    seriesId: 900001,
    gameweek: 5,
    lockAt: hoursFromNow(52),
    entrants: 1_248,
    capacity: 5_000,
    fixtureIds: [],
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'contest_monthly',
    name: 'Monthly League',
    period: 'October',
    status: 'open',
    seriesId: 900001,
    gameweek: 5,
    lockAt: hoursFromNow(52),
    entrants: 3_902,
    capacity: null,
    fixtureIds: [],
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'contest_full',
    name: 'Head to Head Cup',
    period: 'Gameweek 5',
    status: 'open',
    seriesId: 900001,
    gameweek: 5,
    lockAt: hoursFromNow(52),
    // Deliberately at capacity, so the full state is exercised in the demo.
    entrants: 512,
    capacity: 512,
    fixtureIds: [],
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'contest_locked',
    name: 'Season Opener',
    period: 'Gameweek 4',
    status: 'settled',
    seriesId: 900001,
    gameweek: 4,
    lockAt: hoursFromNow(-96),
    entrants: 4_410,
    capacity: null,
    fixtureIds: [],
    createdAt: now,
    updatedAt: now,
  },
];
